// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23212529%27%3E%3Cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23052c65%27%3E%3Cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%236ea8fe%27%3E%3Cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
    --bs-card-color: var(--bs-body-color);
    --bs-card-bg: var(--bs-body-bg);
    --bs-card-transition: color 0.15s ease-in-out,background-color 0.15s ease-in-out,border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out,border-radius 0.15s ease;
    --bs-card-border-color: var(--bs-border-color);
    --bs-card-border-width: var(--bs-border-width);
    --bs-card-border-radius: var(--bs-border-radius);
    --bs-card-inner-border-radius: calc(var(--bs-border-radius) - var(--bs-border-width));
    --bs-card-btn-padding-x: 1.25rem;
    --bs-card-btn-padding-y: 1rem;
    --bs-card-btn-color: var(--bs-body-color);
    --bs-card-btn-bg: var(--bs-card-bg);
    --bs-card-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    --bs-card-btn-icon-width: 1.25rem;
    --bs-card-btn-icon-transform: rotate(-180deg);
    --bs-card-btn-icon-transition: transform 0.2s ease-in-out;
    --bs-card-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    --bs-card-btn-focus-border-color: #86b7fe;
    --bs-card-btn-focus-box-shadow: 0 0 0 0.25rem #0d6efd40;
    --bs-card-body-padding-x: 1.25rem;
    --bs-card-body-padding-y: 1rem;
    --bs-card-active-color: var(--bs-primary-text-emphasis);
    --bs-card-active-bg: var(--bs-primary-bg-subtle);
    overflow: hidden;
}
.collapse {
    display: none;
    transition: all 0.3s ease-in-out;
}
.collapse.show {
    display: block;
}
.collapsing {
    height: 0;
    overflow: hidden;
}
.card-header {
    display: block !important;
    padding: 5px !important;
    align-items: center;
    background-color: rgba(0,0,0,.05);
    border: solid 1px darkgrey;
    border-radius: 0;
    color: var(--bs-card-btn-color);
    display: flex;
    font-size: 1rem;
    overflow-anchor: none;
    position: relative;
    text-align: left;
    transition: var(--bs-card-transition);
    width: 100%;
    margin-top: 0;
    margin-bottom: 0;
}
.card-body {
    margin-left: 20px;
}
.card-body * {
    color: #6e6e6e;
}
.card-body label {
	margin-left: 5px;
}
.card-body span {
    float: right;
}
.card-button {
    border: none;
    padding: 0;
}

@media (prefers-reduced-motion:reduce) {
    .card-button {
        transition: none
    }
}

.card-button:not(.collapsed) {
    background-color: var(--bs-card-active-bg);
    box-shadow: inset 0 calc(var(--bs-card-border-width)*-1) 0 var(--bs-card-border-color);
    color: var(--bs-card-active-color)
}

.card-button:not(.collapsed):after {
    transform: var(--bs-card-btn-icon-transform)
}

.card-button:after {
    background-repeat: no-repeat;
    background-size: var(--bs-card-btn-icon-width);
    content: "";
    flex-shrink: 0;
    height: var(--bs-card-btn-icon-width);
    margin-left: auto;
    transition: var(--bs-card-btn-icon-transition);
    width: var(--bs-card-btn-icon-width)
}

@media (prefers-reduced-motion:reduce) {
    .card-button:after {
        transition: none
    }
}

.card-button:hover {
    z-index: 2
}

.card-button:focus {
    border-color: var(--bs-card-btn-focus-border-color);
    box-shadow: var(--bs-card-btn-focus-box-shadow);
    outline: 0;
    z-index: 3
}

.card-item {
    background-color: var(--bs-card-bg);
    border: var(--bs-card-border-width) solid var(--bs-card-border-color);
    color: var(--bs-card-color);
}

.card-item:first-of-type {
    border-top-left-radius: var(--bs-card-border-radius);
    border-top-right-radius: var(--bs-card-border-radius)
}

.card-item:first-of-type .card-button {
    border-top-left-radius: var(--bs-card-inner-border-radius);
    border-top-right-radius: var(--bs-card-inner-border-radius)
}

.card-item:not(:first-of-type) {
    border-top: 0
}

.card-item:last-of-type {
    border-bottom-left-radius: var(--bs-card-border-radius);
    border-bottom-right-radius: var(--bs-card-border-radius)
}

.card-item:last-of-type .card-button.collapsed {
    border-bottom-left-radius: var(--bs-card-inner-border-radius);
    border-bottom-right-radius: var(--bs-card-inner-border-radius);
}

.card-item:last-of-type .card-collapse {
    border-bottom-left-radius: var(--bs-card-border-radius);
    border-bottom-right-radius: var(--bs-card-border-radius)
}

.card-flush .card-collapse {
    border-width: 0
}

.card-flush .card-item {
    border-left: 0;
    border-radius: 0;
    border-right: 0
}

.card-flush .card-item:first-child {
    border-top: 0
}

.card-flush .card-item:last-child {
    border-bottom: 0
}

.card-flush .card-item .card-button,.card-flush .card-item .card-button.collapsed {
    border-radius: 0
}

[data-bs-theme=dark] .card-button:after {
    --bs-card-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    --bs-card-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_2___})
}`, "",{"version":3,"sources":["webpack://./src/styles/BookingData.css"],"names":[],"mappings":"AAAA;IACI,qCAAqC;IACrC,+BAA+B;IAC/B,qKAAqK;IACrK,8CAA8C;IAC9C,8CAA8C;IAC9C,gDAAgD;IAChD,qFAAqF;IACrF,gCAAgC;IAChC,6BAA6B;IAC7B,yCAAyC;IACzC,mCAAmC;IACnC,2DAAiT;IACjT,iCAAiC;IACjC,6CAA6C;IAC7C,yDAAyD;IACzD,kEAAwT;IACxT,yCAAyC;IACzC,uDAAuD;IACvD,iCAAiC;IACjC,8BAA8B;IAC9B,uDAAuD;IACvD,gDAAgD;IAChD,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,gCAAgC;AACpC;AACA;IACI,cAAc;AAClB;AACA;IACI,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,uBAAuB;IACvB,mBAAmB;IACnB,iCAAiC;IACjC,0BAA0B;IAC1B,gBAAgB;IAChB,+BAA+B;IAC/B,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,qCAAqC;IACrC,WAAW;IACX,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,cAAc;AAClB;AACA;CACC,gBAAgB;AACjB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;IACZ,UAAU;AACd;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,0CAA0C;IAC1C,sFAAsF;IACtF;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,4BAA4B;IAC5B,8CAA8C;IAC9C,WAAW;IACX,cAAc;IACd,qCAAqC;IACrC,iBAAiB;IACjB,8CAA8C;IAC9C;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mDAAmD;IACnD,+CAA+C;IAC/C,UAAU;IACV;AACJ;;AAEA;IACI,mCAAmC;IACnC,qEAAqE;IACrE,2BAA2B;AAC/B;;AAEA;IACI,oDAAoD;IACpD;AACJ;;AAEA;IACI,0DAA0D;IAC1D;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uDAAuD;IACvD;AACJ;;AAEA;IACI,6DAA6D;IAC7D,8DAA8D;AAClE;;AAEA;IACI,uDAAuD;IACvD;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,2DAAiT;IACjT;AACJ","sourcesContent":[".card {\n    --bs-card-color: var(--bs-body-color);\n    --bs-card-bg: var(--bs-body-bg);\n    --bs-card-transition: color 0.15s ease-in-out,background-color 0.15s ease-in-out,border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out,border-radius 0.15s ease;\n    --bs-card-border-color: var(--bs-border-color);\n    --bs-card-border-width: var(--bs-border-width);\n    --bs-card-border-radius: var(--bs-border-radius);\n    --bs-card-inner-border-radius: calc(var(--bs-border-radius) - var(--bs-border-width));\n    --bs-card-btn-padding-x: 1.25rem;\n    --bs-card-btn-padding-y: 1rem;\n    --bs-card-btn-color: var(--bs-body-color);\n    --bs-card-btn-bg: var(--bs-card-bg);\n    --bs-card-btn-icon: url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23212529'%3E%3Cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E\");\n    --bs-card-btn-icon-width: 1.25rem;\n    --bs-card-btn-icon-transform: rotate(-180deg);\n    --bs-card-btn-icon-transition: transform 0.2s ease-in-out;\n    --bs-card-btn-active-icon: url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23052c65'%3E%3Cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E\");\n    --bs-card-btn-focus-border-color: #86b7fe;\n    --bs-card-btn-focus-box-shadow: 0 0 0 0.25rem #0d6efd40;\n    --bs-card-body-padding-x: 1.25rem;\n    --bs-card-body-padding-y: 1rem;\n    --bs-card-active-color: var(--bs-primary-text-emphasis);\n    --bs-card-active-bg: var(--bs-primary-bg-subtle);\n    overflow: hidden;\n}\n.collapse {\n    display: none;\n    transition: all 0.3s ease-in-out;\n}\n.collapse.show {\n    display: block;\n}\n.collapsing {\n    height: 0;\n    overflow: hidden;\n}\n.card-header {\n    display: block !important;\n    padding: 5px !important;\n    align-items: center;\n    background-color: rgba(0,0,0,.05);\n    border: solid 1px darkgrey;\n    border-radius: 0;\n    color: var(--bs-card-btn-color);\n    display: flex;\n    font-size: 1rem;\n    overflow-anchor: none;\n    position: relative;\n    text-align: left;\n    transition: var(--bs-card-transition);\n    width: 100%;\n    margin-top: 0;\n    margin-bottom: 0;\n}\n.card-body {\n    margin-left: 20px;\n}\n.card-body * {\n    color: #6e6e6e;\n}\n.card-body label {\n\tmargin-left: 5px;\n}\n.card-body span {\n    float: right;\n}\n.card-button {\n    border: none;\n    padding: 0;\n}\n\n@media (prefers-reduced-motion:reduce) {\n    .card-button {\n        transition: none\n    }\n}\n\n.card-button:not(.collapsed) {\n    background-color: var(--bs-card-active-bg);\n    box-shadow: inset 0 calc(var(--bs-card-border-width)*-1) 0 var(--bs-card-border-color);\n    color: var(--bs-card-active-color)\n}\n\n.card-button:not(.collapsed):after {\n    transform: var(--bs-card-btn-icon-transform)\n}\n\n.card-button:after {\n    background-repeat: no-repeat;\n    background-size: var(--bs-card-btn-icon-width);\n    content: \"\";\n    flex-shrink: 0;\n    height: var(--bs-card-btn-icon-width);\n    margin-left: auto;\n    transition: var(--bs-card-btn-icon-transition);\n    width: var(--bs-card-btn-icon-width)\n}\n\n@media (prefers-reduced-motion:reduce) {\n    .card-button:after {\n        transition: none\n    }\n}\n\n.card-button:hover {\n    z-index: 2\n}\n\n.card-button:focus {\n    border-color: var(--bs-card-btn-focus-border-color);\n    box-shadow: var(--bs-card-btn-focus-box-shadow);\n    outline: 0;\n    z-index: 3\n}\n\n.card-item {\n    background-color: var(--bs-card-bg);\n    border: var(--bs-card-border-width) solid var(--bs-card-border-color);\n    color: var(--bs-card-color);\n}\n\n.card-item:first-of-type {\n    border-top-left-radius: var(--bs-card-border-radius);\n    border-top-right-radius: var(--bs-card-border-radius)\n}\n\n.card-item:first-of-type .card-button {\n    border-top-left-radius: var(--bs-card-inner-border-radius);\n    border-top-right-radius: var(--bs-card-inner-border-radius)\n}\n\n.card-item:not(:first-of-type) {\n    border-top: 0\n}\n\n.card-item:last-of-type {\n    border-bottom-left-radius: var(--bs-card-border-radius);\n    border-bottom-right-radius: var(--bs-card-border-radius)\n}\n\n.card-item:last-of-type .card-button.collapsed {\n    border-bottom-left-radius: var(--bs-card-inner-border-radius);\n    border-bottom-right-radius: var(--bs-card-inner-border-radius);\n}\n\n.card-item:last-of-type .card-collapse {\n    border-bottom-left-radius: var(--bs-card-border-radius);\n    border-bottom-right-radius: var(--bs-card-border-radius)\n}\n\n.card-flush .card-collapse {\n    border-width: 0\n}\n\n.card-flush .card-item {\n    border-left: 0;\n    border-radius: 0;\n    border-right: 0\n}\n\n.card-flush .card-item:first-child {\n    border-top: 0\n}\n\n.card-flush .card-item:last-child {\n    border-bottom: 0\n}\n\n.card-flush .card-item .card-button,.card-flush .card-item .card-button.collapsed {\n    border-radius: 0\n}\n\n[data-bs-theme=dark] .card-button:after {\n    --bs-card-btn-icon: url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%236ea8fe'%3E%3Cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E\");\n    --bs-card-btn-active-icon: url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%236ea8fe'%3E%3Cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E\")\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
